import { connect } from 'react-redux';

import { StoreState } from '../../reducers';
import ProposalStatsPage from '../../components/ProposalStatsPage';

const mapStateToProps = (state: StoreState) => {
	const {
		proposalStats: {
			proposalStatus,
			paginator: { page, totalPages },
			allIds,
			isLoading,
		},
	} = state;

	return {
		proposalStatus,
		page,
		totalPages,
		isResetNeeded: page === 0 && allIds.length === 0,
		isLoading,
	};
};

export default connect(mapStateToProps)(ProposalStatsPage);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/ProposalStatsPage/index.tsx